import MobileDesignAPIs from '@/API/design/mobile-design-api'

export default {
  namespaced: true,

  state: {
    themes: [],
    forms: [],
    themesFetched: false,
  },

  getters: {
    currentThemes: (state: any) => state.themes,
    forms: (state: any) => state.forms ?? [],
    themesFetched: (state: any) => state.themesFetched,
    activeMobileTheme: (state: any) => state.themes.find((theme: any) => theme.active),
  },

  mutations: {
    SET_THEMES(state: any, payload: any) {
      const { themes, forms } = payload
      state.themes = themes
      state.forms = forms
      state.themesFetched = true
    },
    UPDATE_THEMES(state: any, themes: any) {
      state.themes = [...themes]
    },
    CLEAR_CACHED_THEMES(state: any) {
      state.themes = {}
      state.themesFetched = false
    },
  },

  actions: {
    RESET(context: any) {
      context.commit('CLEAR_CACHED_THEMES')
    },
    ADD_THEME(context: any, theme: any) {
      context.commit('UPDATE_THEMES', [theme, ...context.getters.currentThemes])
    },
    UPDATE_THEME(context: any, theme: any) {
      const index = context.getters.currentThemes.findIndex((t: any) => t.id.toString === theme.id.toString)
      if (index > -1) {
        const themes = [...context.state.themes]
        const newTheme = { ...theme, active: themes[index].active }
        themes[index] = { ...newTheme }
        context.commit('UPDATE_THEMES', themes)
      }
    },
    async FETCH_THEMES(context: any, force: false) {
      if (context.state.themesFetched && !force) return context.state.themes
      const themes = await MobileDesignAPIs.getThemesList()
      context.commit('SET_THEMES', themes)
      return themes
    },
  },
}
